<template>
  <div>
    <van-popup v-model="show" :style="{ borderRadius: '.1rem' }">
      <div class="success-box">
        <div class="title">爱在点点滴滴</div>
        <div class="title">欢迎您加入汀咚大家庭！</div>
        <Btn title="确认" width="2.18rem" @click="show = false" />
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        show: false
      }
    },
    mounted () {
      this.$Bus.$on(this.$EmitType['OpenRegisterSucc'], () => {
        this.show = true
      })
    }
  }
</script>

<style lang="less" scoped>
  .success-box {
    .w(5.72rem);
    .pt(.78rem);
    .pb(.45rem);
    .flex-ccc();
    .title {
      .fz(.34rem);
      .c(#333);
      font-weight: bold;
      & + .title {
        .mt(.2rem);
        .mb(.7rem);
      }
    }
  }
</style>
